import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './route-tag.component.html',
  styleUrls: ['./route-tag.component.css'],
})
export class RouteTagComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
